import { useState } from "react";

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export type UsePaginationStateReturnType = {
  reset: () => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  currentPageSize: number;
  setCurrentPageSize: (pageSize: number) => void;
  hasNextPage: boolean;
  setHasNextPage: (hasNextPage: boolean) => void;
  isFetchingNextPage: boolean;
  setIsFetchingNextPage: (isFetchingNextPage: boolean) => void;
};

export const usePaginationState = (
  initialPage: number = DEFAULT_PAGE_NUMBER,
  initialPageSize: number = DEFAULT_PAGE_SIZE,
): UsePaginationStateReturnType => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [currentPageSize, setCurrentPageSize] = useState(initialPageSize);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);

  return {
    reset: () => {
      setCurrentPage(initialPage);
      setCurrentPageSize(initialPageSize);
    },
    currentPage,
    setCurrentPage,
    currentPageSize,
    setCurrentPageSize,
    hasNextPage,
    setHasNextPage,
    isFetchingNextPage,
    setIsFetchingNextPage,
  };
};
